import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_3256_103820)">
      <path
        d="M0.935913 11.8828V12.9696C0.935913 13.546 1.16491 14.0989 1.57253 14.5066C1.98015 14.9141 2.533 15.1432 3.10946 15.1432H12.8905C13.4669 15.1432 14.0197 14.9141 14.4274 14.5066C14.8349 14.0989 15.0639 13.546 15.0639 12.9696V11.8828"
        stroke="#999999"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7755 4.60645C11.035 3.24359 9.93211 2.00161 8.5113 1.14262C8.19662 0.952378 7.80306 0.952389 7.4884 1.14265C6.06765 2.0017 4.96476 3.24362 4.22423 4.60645"
        stroke="#999999"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 1.14272L8 10.5947" stroke="#999999" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_3256_103820">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const UploadBigIcon = memo(ForwardRef);
export default UploadBigIcon;
